<div class="application-view-main-container">
  <div class="application-view-title">{{ viewTitle }}</div>

  <div class="points-amount-label points-amount-label-error" *ngIf="!campaignActive && !isAdminView">
    Zakładka będzie aktywna po zakończeniu promocji i złożeniu zamówienia.
  </div>

  <ng-container *ngIf="campaignActive || isAdminView">
  <ng-container *ngIf="hasOrder; else noOrder">
    <div class="order-header">
      <div class="order-summary">
        <span>Kampania: {{ campaignName }}</span>
        <span>Data zamówienia: {{ formattedOrderDate }}</span>
        <span>Łączna wartość: {{ orderTotal }} zł</span>
        <span *ngIf="parcelLocker?.name">
          Paczkomat: {{ parcelLocker.name }}<ng-container *ngIf="parcelLocker?.address">, {{ parcelLocker.address }}</ng-container><ng-container *ngIf="parcelLocker?.city">, {{ parcelLocker.city }}</ng-container><ng-container *ngIf="parcelLocker?.postCode">, {{ parcelLocker.postCode }}</ng-container>
        </span>
      </div>
      <div class="order-actions">
        <button type="button" class="btn btn-primary btn-primary-custom" (click)="downloadPdf()">Pobierz PDF</button>
      </div>
    </div>
    <div class="cart-items-container">
      <div class="app-card-wrapper" *ngFor="let item of items">
        <div class="app-card-image-and-data-container">
          <div class="app-card-image-container">
            <img [src]="item.imageUrl"/>
          </div>
          <div class="app-card-data-container">
            <div class="cart-item-info-container">
              <span class="benefit-title app-card-text-underline">{{ item.name }}</span>
              <div class="cart-item-additional-data-container order-item-data">
                <span>Koszt jednostkowy: {{ item.unitPrice }} zł</span>
                <span>Ilość: {{ item.quantity }}</span>
                <span>Koszt sumaryczny: {{ item.lineTotal }} zł</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #noOrder>
    <div class="cart-empty-label">Brak zamówienia do wyświetlenia</div>
  </ng-template>
  </ng-container>
</div>
<waiting-spinner *ngIf="isSpinnerVisible" [text]="'Wczytywanie zamówienia...'"></waiting-spinner>
